module.exports = __webpack_public_path__ + "img/empty-3.194ec5c2.svg";